import store from '../../store'
import moment from 'moment'
import { merge } from 'lodash'
import PGSHelper from '../../helpers/PGSHelper.js';

export default class OrdenesCompra {
    static typeSearch = "local" //online || local
    static rules = {
        Requerido: [(value) => !!value || 'El campo obligatorio'],
    }

    static statusList =  [
      {id:"P", name:"Pendiente"},
      {id:"A", name:"Aprobado"},
      {id:"F", name:"Finalizado"},
      /*{id:"Producto-SSal",name:"Producto de solo salidas"}*/
    ]
    constructor(data = null) {
        this.Id = (data?.id) ? data.id : null;
        this.sts = (data?.sts) ? data.sts : "P";
        this.amc = (data?.amc) ? data.amc : "";
        this.mmt = (data?.mmt) ? data?.mmt: '';
        this.Tenant = (data?.Tenant) ? data.Tenant : store.getters.getFirebaseApp.tenant;
        this.req = (data?.req) ? data.req : []
        this.dpt = (data?.dpt) ? data.dpt : []
    }



    static getPropertyModel() {
        return this;
    }

    static getStatusList(){
      return this.statusList;
    }

    static async getOrdeneCompra() {

        const firestore = store.getters.getFirebaseApp.firestore
        const data = await firestore
            .queryBuilder("AMC_Presentaciones",
                [
                ]
            )
        if (data.empty) {
            return [];
        } else {
            let doc = data.docs.map(doc => { return { Id: doc.ref.id, ...doc.data() } });
            return doc;
        }
    }
    static getRules() {
        return this.rules;
    }



}